import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarMenu from "../Component/SideBarMenu";

import TopHeader from "../Component/TopHeader";
import PaymentsFilters from "../Component/Filters/PaymentsFilters";
import FilterPopover from "../Component/FilterPopover";
import StatusDot from "../Component/StatusDot";
import Pagination from "../Component/Pagination";
import { getAdminPaymentsAction } from "../../Store/Actions/AdminActions";
import { display, showToast } from "../../utils/helper";

const PaymentsList = () => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  const { adminPayments } = useSelector((state) => state.bookings);

  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  const stripEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    );

  const [pagging, setPagging] = useState({
    totalItems: "",
    itemsPerPage: "",
    currentPage: "",
    totalPages: "",
    nextPage: 1,
    limit: 15,
  });

  const getPaymentsList = (page = 1, overrideFilters) => {
    if (loading) return;
    setLoading(true);

    const listParams = {
      page,
      limit: pagging.limit,
      ...stripEmpty(overrideFilters || filters),
    };

    getAdminPaymentsAction(listParams, dispatch)
      .then((res) => {
        if (res && res.type === "success" && res.pagination) {
          setPagging((prev) => ({ ...prev, ...res.pagination }));
        }
      })
      .catch((err) =>
        showToast("error", (err && err.message) || "Could not load payments"),
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPaymentsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderPagging = () => (
    <Pagination
      currentPage={pagging.currentPage || 1}
      totalPages={pagging.totalPages || 1}
      totalItems={pagging.totalItems}
      onPageChange={(p) => getPaymentsList(p)}
    />
  );

  return (
    <div className={`app-wrapper ${menuState ? "open" : ""} `}>
      <SideBarMenu />

      <div className="content-wrapper">
        <TopHeader title={"Payments"} />

        <div className="content">
          <div className="list-toolbar">
            <div className="list-toolbar-spacer" />

            <FilterPopover
              count={
                Object.values(filters).filter(
                  (v) => v !== "" && v !== null && v !== undefined,
                ).length
              }
            >
              {(close) => (
                <PaymentsFilters
                  admin
                  initial={filters}
                  onApply={(values) => {
                    setFilters(values);
                    getPaymentsList(1, values);
                    close();
                  }}
                />
              )}
            </FilterPopover>
          </div>

          <div className="data-listing">
            <table className="table">
              <thead className="thead-light">
                <tr>
                  <th width="14%">Spot</th>
                  <th width="20%">Address</th>
                  <th width="10%" className="text-center">
                    Amount
                  </th>
                  <th width="18%" className="text-center">
                    Transaction ID
                  </th>
                  <th width="11%">Status</th>
                  <th width="11%">Updated</th>
                </tr>
              </thead>
              <tbody>
                {adminPayments.length > 0 &&
                  adminPayments.map((item) => (
                    <tr key={`pmt-${item.id}`}>
                      <td>{display(item.spot && item.spot.name)}</td>
                      <td>{display(item.spot && item.spot.address)}</td>
                      <td className="text-center">
                        ${display(item.totalAmount || item.grossAmount, "0")}
                      </td>
                      <td className="text-center">
                        {display(item.stripePaymentIntentId)}
                      </td>
                      <td>
                        <StatusDot status={item.status} kind="payment" />
                      </td>
                      <td>
                        {item.updatedAt
                          ? new Date(item.updatedAt).toLocaleDateString(
                              undefined,
                              {
                                year: "2-digit",
                                month: "2-digit",
                                day: "2-digit",
                              },
                            )
                          : "—"}
                      </td>
                    </tr>
                  ))}

                {adminPayments.length === 0 && !loading && (
                  <tr>
                    <td colSpan="6">
                      <p className="text-center mb-0">No Payments Available.</p>
                    </td>
                  </tr>
                )}

                {loading && (
                  <tr>
                    <td colSpan="6">
                      <p className="text-center mb-0">
                        <i className="fas fa-spinner fa-spin" />
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {renderPagging()}
        </div>
      </div>
    </div>
  );
};

export default PaymentsList;
